module.exports = __webpack_public_path__ + "static/img/bg63.b563c1c1.png";